import { render } from "./GeneralTextAreaField.vue?vue&type=template&id=4d36667c&scoped=true"
import script from "./GeneralTextAreaField.vue?vue&type=script&lang=js"
export * from "./GeneralTextAreaField.vue?vue&type=script&lang=js"

import "./GeneralTextAreaField.vue?vue&type=style&index=0&id=4d36667c&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d36667c"]])

export default __exports__